import script from "./bi-tmpl-detail-4-3-2.vue?vue&type=script&lang=ts&setup=true"
export * from "./bi-tmpl-detail-4-3-2.vue?vue&type=script&lang=ts&setup=true"

import "./bi-tmpl-detail-4-3-2.vue?vue&type=style&index=0&id=1165e404&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1165e404"]])

export default __exports__